class ProductPageTabs extends HTMLElement {
  connectedCallback() {
    console.log('ProductPageTabs connected');
    this.drawerId = this.dataset.drawerId;
    this.drawer = this.querySelector(`#${CSS.escape(this.drawerId)}`) || document.getElementById(this.drawerId);

    if (!this.drawer) return;

    this.triggerButtons = Array.from(document.querySelectorAll('.product-page-tabs__trigger'));
    this.tabButtons = Array.from(this.querySelectorAll('.product-page-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.product-page-tabs__panel'));

    const firstTabId =
      this.triggerButtons[0]?.dataset.tabId ||
      this.tabButtons[0]?.dataset.tabId ||
      this.panels[0]?.dataset.tabId;

    if (firstTabId) this.setActiveTab(firstTabId);

    this.triggerButtons.forEach((btn) => {
    const stop = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    btn.addEventListener('pointerdown', stop);

    btn.addEventListener('click', (e) => {
        stop(e);

        const tabId = btn.dataset.tabId;
        this.setActiveTab(tabId);

        this._pendingOpenTabId = tabId;
        requestAnimationFrame(() => {
        if (this._pendingOpenTabId === tabId) this.openDrawer();
        });
    });
    });

    this.tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const tabId = btn.dataset.tabId;
        this.setActiveTab(tabId);
      });
    });

    this.drawer.addEventListener('close', () => this.setExpanded(false));
    this.drawer.addEventListener('open', () => this.setExpanded(true));

    this._observer = new MutationObserver(() => {
      const isOpen =
        this.drawer.hasAttribute('open') ||
        this.drawer.getAttribute('aria-hidden') === 'false';

      this.setExpanded(!!isOpen);
    });

    this._observer.observe(this.drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  setExpanded(expanded) {
    this.triggerButtons.forEach((btn) => btn.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
  }

  openDrawer() {
    if (typeof this.drawer.open === 'function') {
      this.drawer.open();
    } else if (typeof this.drawer.show === 'function') {
      this.drawer.show();
    } else {
      this.drawer.setAttribute('open', '');
      this.drawer.removeAttribute('aria-hidden');
    }

    this.setExpanded(true);
  }

  setActiveTab(tabId) {
  if (!tabId) return;

  this.panels.forEach((panel) => {
    const isActive = panel.dataset.tabId === tabId;

    panel.classList.toggle('active', isActive);
    panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  });

  this.tabButtons.forEach((btn) => {
    const isActive = btn.dataset.tabId === tabId;

    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    btn.tabIndex = isActive ? 0 : -1;
    btn.classList.toggle('is-active', isActive);
  });

  this.triggerButtons.forEach((btn) => {
    const isActive = btn.dataset.tabId === tabId;
    btn.classList.toggle('is-active', isActive);
  });
}
}

customElements.define('product-page-tabs', ProductPageTabs);